module.exports = __webpack_public_path__ + "img/once_en.0fd8b979.png";